import React from "react";

// components
import Modal from "../../../components/ui/modal";
import TextInput from "../../../components/elements/form/TextInput";

// states
import { useAppDispatch, useAppSelector } from "../../../store";
import { IUpdateUser, IUpdateUserError } from "../../../store/@types/user";
import Button from "../../../components/elements/form/Button";
import { update } from "../../../service/api/auth";

type IEdiProfile = {
  open: boolean;
  onClose: () => void;
};

const EdiProfile: React.FC<IEdiProfile> = ({ open, onClose }) => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(({ auth }) => auth.user);
  const loading = useAppSelector(({ auth }) => auth.loading);
  const [data, dataSet] = React.useState<IUpdateUser>({
    address: "",
    name: "",
    nin_number: "",
    phone_number: "",
  });

  const [err, errSet] = React.useState<IUpdateUserError>({
    address: "",
    name: "",
    nin_number: "",
    phone_number: "",
  });

  const onLoad = React.useCallback(() => {
    if (user)
      dataSet({
        address: user?.profile?.address || "",
        name: user?.profile?.name || "",
        nin_number: user?.profile?.nin_number || "",
        phone_number: user?.profile?.phone || "",
      });
  }, [user]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    dataSet((prev) => ({ ...prev, [name]: value }));
    errSet((prev) => ({ ...prev, [name]: "" }));
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        onClose();
        dataSet({
          address: "",
          name: "",
          nin_number: "",
          phone_number: "",
        });
      }}
    >
      <div className="space-y-6">
        <div className="mt-3 md:mt-0">
          <TextInput
            label="Full Name"
            name="name"
            placeholder="John Doe"
            required={true}
            type="text"
            value={data.name}
            status={err.name}
            onChange={handleChange}
          />
        </div>

        <TextInput
          label="Phone Number"
          name="phone_number"
          placeholder="234 903 333 3333"
          required={true}
          type="text"
          value={data.phone_number}
          status={err.phone_number}
          onChange={handleChange}
        />

        <TextInput
          label="Address"
          name="address"
          placeholder="23, Osborne road"
          required={true}
          type="text"
          value={data.address}
          status={err.address}
          onChange={handleChange}
        />

        <TextInput
          label="Identity Number"
          name="nin_number"
          placeholder="1099955445"
          required={false}
          type="text"
          value={data.nin_number}
          status={err.nin_number}
          onChange={handleChange}
        />

        <Button
          className="bg-primary-500 rounded-lg hover:bg-primary-700 transition-colors 300"
          title="Update"
          type="button"
          loading={loading}
          onHandler={async () => {
            let validate: boolean = false;
            if (!data.name) {
              validate = true;
              errSet((prev) => ({ ...prev, name: "" }));
            }
            if (!data.address) {
              validate = true;
              errSet((prev) => ({ ...prev, address: "" }));
            }
            if (!data.phone_number) {
              validate = true;
              errSet((prev) => ({ ...prev, phone: "" }));
            }
            if (validate) return;
            const response = await update(dispatch, data);
            if (response) {
              onClose();
              dataSet({
                address: "",
                name: "",
                nin_number: "",
                phone_number: "",
              });
            }
          }}
        />
      </div>
    </Modal>
  );
};

export default EdiProfile;
